import { render, staticRenderFns } from "./PassesSearch.vue?vue&type=template&id=2508b244"
import script from "./PassesSearch.vue?vue&type=script&lang=ts"
export * from "./PassesSearch.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports